var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.hasData)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('RiskIndexObservationsDetail',{attrs:{"organizationId":_vm.organizationId,"reportId":_vm.reportId,"report":_vm.report}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }